import React, { useEffect } from 'react'
import builderImage from '../pictures/builderImageWaterMark.jpeg'
import { useDispatch, useSelector } from 'react-redux';
import { fetchAdaptionForStaffMember, fetchCompanyDetails, fetchJobsForStaffMember, fetchQoutaionForStaffMember, signOut, staffActions } from '../store/staffSlice';
import StaffLogo from '../components/StaffLogo';
import { useNavigate } from 'react-router-dom';
import WorkIcon from '@mui/icons-material/Work';
import BuildIcon from '@mui/icons-material/Build';
import DeleteIcon from '@mui/icons-material/Delete';
import RefreshIcon from '@mui/icons-material/Refresh';
import LogoutIcon from '@mui/icons-material/Logout';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PendingIcon from '@mui/icons-material/Pending';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

function StaffJobList() {
    const navigate = useNavigate();
    const dispatch=useDispatch();
    const adminID = useSelector((state) => state.staff.adminID)
    const ID = useSelector((state) => state.staff.staff_id)
    const stateJobsForStaffMember = useSelector((state) => state.staff.jobsForStaffMember)
    const adaptionsForStaffMember = useSelector((state) => state.staff.adaptionsForStaffMember)
    const qoutaionForStaffMember = useSelector((state) => state.staff.qoutaionForStaffMember)
    const StatesignOut = useSelector((state) => state.staff.signOut);

    useEffect(()=>{
       
    },[stateJobsForStaffMember])
    
    useEffect(() => {
        dispatch(fetchCompanyDetails({adminID:adminID}))
        dispatch(fetchJobsForStaffMember({_id:ID}))
        dispatch(fetchQoutaionForStaffMember({ _id: ID }))
        dispatch(fetchAdaptionForStaffMember({ _id: ID }))
    }, [])

    useEffect(() => {
        if (StatesignOut === "signOut" || ID==="") {
            dispatch(staffActions.removesignout())
            dispatch(staffActions.signout())
            navigate("/")
        }
    },[StatesignOut])

    const signout = () => {
        dispatch(signOut())
    }

    const getStatusIcon = (status) => {
        switch(status) {
            case 0:
                return <PendingIcon className="text-yellow-500" fontSize="small" />;
            case 1:
                return <PlayCircleIcon className="text-blue-500" fontSize="small" />;
            case 2:
                return <CheckCircleIcon className="text-green-500" fontSize="small" />;
            default:
                return <PendingIcon className="text-gray-500" fontSize="small" />;
        }
    };

    const getStatusText = (status) => {
        switch(status) {
            case 0: return "Pending";
            case 1: return "In Progress";
            case 2: return "Completed";
            default: return "Unknown";
        }
    };

    const JobCard = ({ job, onClick, type = "job" }) => (
        <div 
            onClick={onClick}
            className='bg-white rounded-lg shadow-sm border border-gray-200 p-4 hover:shadow-md hover:border-lightgreen transition-all cursor-pointer'
        >
            <div className='flex items-center justify-between'>
                <div className='flex items-center space-x-3 flex-1'>
                    <div className='w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center'>
                        {type === 'job' && <WorkIcon className="text-lightgreen" />}
                        {type === 'adaption' && <BuildIcon className="text-blue-500" />}
                        {type === 'dismantle' && <DeleteIcon className="text-red-500" />}
                    </div>
                    <div className='flex-1 min-w-0'>
                        <div className='flex items-center space-x-2 mb-1'>
                            <LocationOnIcon className="text-gray-400" fontSize="small" />
                            <p className='font-medium text-gray-800 truncate'>
                                {type === 'dismantle' ? `${job.jobID.job1} ${job.jobID.job2}` : `${job.job1} ${job.job2}`}
                            </p>
                        </div>
                        <div className='flex items-center space-x-2'>
                            {getStatusIcon(type === 'dismantle' ? 1 : job.status)}
                            <span className='text-sm text-gray-600'>
                                {type === 'dismantle' ? 'Ready for Dismantle' : getStatusText(job.status)}
                            </span>
                        </div>
                    </div>
                </div>
                <ArrowForwardIosIcon className="text-gray-400" fontSize="small" />
            </div>
        </div>
    );

    const SectionHeader = ({ icon, title, count }) => (
        <div className='flex items-center justify-between mb-4'>
            <div className='flex items-center space-x-2'>
                {icon}
                <h2 className='text-lg font-semibold text-gray-800'>{title}</h2>
                {count > 0 && (
                    <span className='bg-lightgreen text-white text-xs px-2 py-1 rounded-full'>
                        {count}
                    </span>
                )}
            </div>
        </div>
    );

    const activeJobs = stateJobsForStaffMember.filter(job => job.status !== 2);
    const activeAdaptions = adaptionsForStaffMember.filter(adaption => adaption.status !== 2);
    const dismantleJobs = qoutaionForStaffMember.filter(job => job.dismantleRequestedDate !== undefined);

    return (
        <div className='w-full h-screen bg-gray-50'>
            {/* Desktop Warning */}
            <div className='hidden lg:flex w-full h-screen items-center justify-center'>
                <div className="bg-red-100 border border-red-400 text-red-700 px-6 py-4 rounded-lg shadow-lg max-w-lg">
                    <strong className="font-bold text-lg">Warning!</strong>
                    <p className="mt-2">This page is only visible on mobile and tablet devices.</p>
                </div>
            </div>

            {/* Mobile/Tablet Layout */}
            <div className='lg:hidden flex flex-col h-screen'>
                {/* Header */}
                <div className='bg-white shadow-sm px-4 py-6'>
                    <div className='flex flex-col items-center space-y-4'>
                        <StaffLogo/>
                        <div className='w-full h-px bg-gray-200'></div>
                        <h1 className='text-2xl font-bold text-gray-800'>My Dashboard</h1>
                    </div>
                </div>

                {/* Main Content */}
                <div className='flex-1 overflow-y-auto px-4 py-6 space-y-6'>
                    {/* Jobs Section */}
                    <div className='bg-white rounded-lg shadow-sm p-4'>
                        <SectionHeader 
                            icon={<WorkIcon className="text-lightgreen" />}
                            title="Active Jobs"
                            count={activeJobs.length}
                        />
                        {activeJobs.length > 0 ? (
                            <div className='space-y-3'>
                                {activeJobs.map((job) => (
                                    <JobCard
                                        key={job._id}
                                        job={job}
                                        onClick={() => navigate(`/staffjob?id=${job._id}&type=${job.typeofScafollding}`)}
                                        type="job"
                                    />
                                ))}
                            </div>
                        ) : (
                            <div className='text-center py-8 text-gray-500'>
                                <WorkIcon className="text-gray-300 mb-2" style={{ fontSize: 48 }} />
                                <p>No active jobs available</p>
                            </div>
                        )}
                    </div>

                    {/* Dismantle Section */}
                    <div className='bg-white rounded-lg shadow-sm p-4'>
                        <SectionHeader 
                            icon={<DeleteIcon className="text-red-500" />}
                            title="Dismantle Requests"
                            count={dismantleJobs.length}
                        />
                        {dismantleJobs.length > 0 ? (
                            <div className='space-y-3'>
                                {dismantleJobs.map((job) => (
                                    <JobCard
                                        key={job._id}
                                        job={job}
                                        onClick={() => navigate(`/staffdismantle?id=${job._id}&jobID=${job.jobID._id}&type=${job.jobID.typeofScafollding}`)}
                                        type="dismantle"
                                    />
                                ))}
                            </div>
                        ) : (
                            <div className='text-center py-8 text-gray-500'>
                                <DeleteIcon className="text-gray-300 mb-2" style={{ fontSize: 48 }} />
                                <p>No dismantle requests</p>
                            </div>
                        )}
                    </div>

                    {/* Adaptions Section */}
                    <div className='bg-white rounded-lg shadow-sm p-4'>
                        <SectionHeader 
                            icon={<BuildIcon className="text-blue-500" />}
                            title="Active Adaptions"
                            count={activeAdaptions.length}
                        />
                        {activeAdaptions.length > 0 ? (
                            <div className='space-y-3'>
                                {activeAdaptions.map((adaption) => (
                                    <JobCard
                                        key={adaption._id}
                                        job={adaption}
                                        onClick={() => navigate(`/staffadaption?id=${adaption._id}&type=${adaption.jobID.typeofScafollding}`)}
                                        type="adaption"
                                    />
                                ))}
                            </div>
                        ) : (
                            <div className='text-center py-8 text-gray-500'>
                                <BuildIcon className="text-gray-300 mb-2" style={{ fontSize: 48 }} />
                                <p>No active adaptions</p>
                            </div>
                        )}
                    </div>
                </div>

                {/* Action Buttons */}
                <div className='bg-white border-t border-gray-200 px-4 py-4 space-y-3'>
                    <button 
                        onClick={() => window.location.reload(true)}
                        className='w-full flex items-center justify-center space-x-2 bg-lightgreen hover:bg-darkgreen text-white py-3 rounded-lg font-medium transition-colors shadow-sm'
                    >
                        <RefreshIcon fontSize="small" />
                        <span>Refresh</span>
                    </button>
                    <button 
                        onClick={signout}
                        className='w-full flex items-center justify-center space-x-2 bg-gray-600 hover:bg-gray-700 text-white py-3 rounded-lg font-medium transition-colors shadow-sm'
                    >
                        <LogoutIcon fontSize="small" />
                        <span>Sign Out</span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default StaffJobList